import { render, staticRenderFns } from "./ReportingHighlightsShort.vue?vue&type=template&id=5137163e&scoped=true&"
import script from "./ReportingHighlightsShort.vue?vue&type=script&lang=js&"
export * from "./ReportingHighlightsShort.vue?vue&type=script&lang=js&"
import style0 from "./ReportingHighlightsShort.vue?vue&type=style&index=0&id=5137163e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137163e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VProgressLinear,VRow})
